<div class="flex flex-middle b-a b-col-4"
     [class.is-busy]="status?.busy">
    <button class="col-1 p-l-1 flex flex-middle"
            [class.is-disabled]="!canLess() || status?.busy"
            [attr.aria-label]="'Remove one item' | translate"
            (click)="less()"
            cy-decreasequantity>
        <i class="icon-minus icon-small m-l-1 m-r-1"
           aria-hidden="true"></i>
    </button>

    <div class="pos-relative">
        <!-- loader -->
        @if (status?.busy) {
        <div class="fill flex flex-middle flex-justify-center">
            <i class="icon-loading"></i>
        </div>
        }

        <input class="no-spinner center p2 m-t-1 m-b-1 qty-input"
               type="number"
               step="1"
               [disabled]="status?.busy || (!canMore() && !canLess()) "
               [attr.min]="min || null"
               cy-quantityinput
               #input
               [(ngModel)]="model"
               (blur)="validate()"
               [minWidth]="18.2"
               autoSizeInput>
    </div>

    <button class="col-1 p-r-1 flex flex-middle"
            [class.is-disabled]="!canMore() || status?.busy"
            [attr.aria-label]="'Add one item' | translate"
            (click)="more()"
            cy-increasequantity>
        <i class="icon-plus icon-small m-l-1 m-r-1"
           aria-hidden="true"></i>
    </button>
</div>
